import "./Header.css";
import React from "react";
import "@fontsource/aref-ruqaa";
import "../../imgs/bakara.jpeg";


const Header = () => {
  return (
    <header className="headerMarq">
      <div>

        <div className="bakaraImg">
          ۞
        </div>

        <div className="headerMarq1">
          <p dir="rtl" className="spany">
            ﴿ ۞ اللَّهُ نُورُ السَّمَاوَاتِ وَالْأَرْضِ ۚ مَثَلُ نُورِهِ
            كَمِشْكَاةٍ فِيهَا مِصْبَاحٌ ۖ الْمِصْبَاحُ فِي زُجَاجَةٍ ۖ
            الزُّجَاجَةُ كَأَنَّهَا كَوْكَبٌ دُرِّيٌّ يُوقَدُ مِن شَجَرَةٍ
            مُّبَارَكَةٍ زَيْتُونَةٍ لَّا شَرْقِيَّةٍ وَلَا غَرْبِيَّةٍ يَكَادُ
            زَيْتُهَا يُضِيءُ وَلَوْ لَمْ تَمْسَسْهُ نَارٌ ۚ نُّورٌ عَلَىٰ نُورٍ
            ۗ يَهْدِي اللَّهُ لِنُورِهِ مَن يَشَاءُ ۚ وَيَضْرِبُ اللَّهُ
            الْأَمْثَالَ لِلنَّاسِ ۗ وَاللَّهُ بِكُلِّ شَيْءٍ عَلِيمٌ ﴾ [ النور:
            35] سورة : النور -الجزء : ( 18 )
          </p>
        </div>

        <div className="headerMarq2">
          <div>
            <p dir="rtl" className="spany">
              <span>
                أسأل المولى العظيم أن ينفع بهذا الموقع الإسلام والمسلمين
              </span>
            </p>
            <p dir="rtl" className="spany">
              <span>وأن يكون خالصاً لوجهه الكريم</span>
            </p>
            <p dir="rtl" className="spany">
              <span>
                وأن يكون صدقة بر أقدمها لأولياء الله الصالحين وأتباعهم
              </span>
            </p>
            <p dir="rtl" className="spany">
              <span>لا تنسوني أنا الفقيره إليه من صالح دعائكم</span>
            </p>
          </div>

          {/*    <marquee direction='left' loop='2' className="spany"> Developed by
                 <a
                    href="https://www.linkedin.com/in/rehamAbass/"
                    target='_blank'
                >  Dev.Reham Abass &copy; 2024
                  </a>
                </marquee> */}

          <p className="spany">
            <span>Developed by Dev.Reham Abass &copy; 2025</span>
            <span> رهام عباس </span>
          </p>

          <p dir="ltr" className="spany">
            <span>soft.rehamabass@gmail.com</span>
          </p>
        </div>
      </div>
    </header>
  );
};

export default Header;
